.trigger {
	display: inline-flex;
}
